export default __webpack_public_path__ + "static/media/4.77634c01.jpg";